import React from "react";
import styled from "@emotion/styled";
import EditorAddIcon from "@atlaskit/icon/glyph/editor/add";

import { Button } from "../../UI/Button";

import { SliderQuestionsTableHead } from "./SliderQuestionsTableHead";
import { SliderQuestionsTableBody } from "./SliderQuestionsTableBody";

import { QUESTIONS_LIMIT } from "../../constants/general";
import { Grid } from "../../UI/Grid";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { EnhancedTable } from "../EnhancedTable";
import { SliderQuestionModal } from "../SliderQuestionModal";
import useAuth from "../../routes/login/AuthContext";

export interface IProps {
  questions: any[];
  onReorder: any;
  onSave: any;
  isLoading?: boolean;
  onRemove: any;
  showTagColumn?: any;
  editDisabled: boolean;
}

const StyledAddButton = styled(Button)`
  height: 40px;
`;

export const SliderQuestionsTable: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const [data, setData] = React.useState<Record<string, any> | boolean>(false);

  const openQuestionHandler = () => setData(true);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <EnhancedTable title="Slider Scale Questions">
          <SliderQuestionsTableHead showTagColumn={props.showTagColumn} />
          <SliderQuestionsTableBody setData={setData} {...props} />
        </EnhancedTable>
      </Grid>
      {props.questions.length <= QUESTIONS_LIMIT && (
        <Grid item xs={12}>
          <ReadOnlyWrapper>
            <StyledAddButton
              appearance="primary"
              onClick={openQuestionHandler}
              isDisabled={isSuperAdminRead() || props.editDisabled}
              iconBefore={<EditorAddIcon label="Plus" />}
            >
              Add a Slider Scale Question
            </StyledAddButton>
          </ReadOnlyWrapper>
        </Grid>
      )}
      <SliderQuestionModal data={data} onHide={setData} onSave={props.onSave} showTagColumn={props.showTagColumn} />
    </Grid>
  );
};

SliderQuestionsTable.defaultProps = {
  questions: [],
};
